module.exports = __webpack_public_path__ + "img/icon_pinterest.8ea97f8e.svg";